import { memo, useEffect } from 'react';
import DrawerPanelBody from '@/components/drawers/DrawerPanelBody';
import useDrawerStore from '@/stores/useDrawerStore';
import { useSidebar } from '@ui/sidebar';

/**
 * Right-hand pane of the mobile sidebar: shows the active drawer view (defaults to Groups).
 */
function MobileSidebarDrawerPane() {
  const activeDrawer = useDrawerStore((state) => state.activeDrawer);
  const openDrawer = useDrawerStore((state) => state.openDrawer);
  const { openMobile } = useSidebar();

  useEffect(() => {
    if (!openMobile) return;
    if (activeDrawer === null) {
      openDrawer('groups');
    }
  }, [openMobile, activeDrawer, openDrawer]);

  const drawerType = activeDrawer ?? 'groups';

  return (
    <div className="text-foreground flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden border-l border-gray-200 dark:border-gray-700">
      <DrawerPanelBody drawerType={drawerType} />
    </div>
  );
}

export default memo(MobileSidebarDrawerPane);
